import { all, put, call, takeEvery } from 'redux-saga/effects'
import { getActivityLogs } from 'services/activityLog'
import actions from './actions'

// The grid's pager only sends size/index: keep the page's last filters (saved by the
// Activity Log page) so page 2 is page 2 of the FILTERED list.
const savedFilters = () => {
  try {
    return JSON.parse(localStorage.getItem('fetchActivityLogs')) || {}
  } catch (e) {
    return {}
  }
}

function* fetchActivityLogs(action) {
  yield put({ type: actions.REQUESTING })
  const result = yield call(getActivityLogs, { ...savedFilters(), ...action })
  yield put({
    type: actions.ACTIVITYLOGS_RECEIVED,
    result: result || { items: [] },
  })
}

export default function* rootSaga() {
  yield all([takeEvery(actions.FETCH_ACTIVITYLOGS, fetchActivityLogs)])
}
